import { S as p } from "./chunk-SwiperElement-DayZ6j1H.js";
import { t as d } from "./chunk-custom-element-ttkHUa8w.js";
import { n as c } from "./chunk-property-Baio2yOX.js";
const g = ".swiper{--swiper-pagination-bottom:5px;--swiper-pagination-bullet-horizontal-gap:3.5px}.swiper-pagination{box-sizing:border-box;justify-content:center;display:flex}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal{width:50%;margin:auto;right:0}.swiper-pagination-bullet{opacity:1;background:0 0;border-radius:0;width:24px;height:24px;position:relative}.swiper-pagination-bullet svg{color:#b8b8b8;width:50%;height:50%;display:block;position:absolute;top:25%;left:25%}.swiper-pagination-bullet-active.swiper-pagination-bullet svg{color:#000}.swiper-pagination-bullet.rolex{--swiper-pagination-bullet-horizontal-gap:8px;opacity:1;will-change:width;background:#d4d4d4;border-radius:4px;width:20px;height:4px;transition:width .3s cubic-bezier(.075,.82,.165,1)}.swiper-pagination-bullet-active.rolex{background:#12784a;width:50px}@media (min-width:768px){.swiper-pagination-bullet.rolex{display:none!important}}";
var h = Object.defineProperty, u = Object.getOwnPropertyDescriptor, s = (e, i, t, o) => {
  for (var a = o > 1 ? void 0 : o ? u(i, t) : i, n = e.length - 1, r; n >= 0; n--)
    (r = e[n]) && (a = (o ? r(i, t, a) : r(a)) || a);
  return o && a && h(i, t, a), a;
};
let l = class extends p {
  constructor() {
    super(...arguments), this.swiperOptions = {
      cssMode: !1,
      injectStyles: this.rcpo ? [] : [g],
      slidesPerView: 1,
      pagination: {
        renderBullet: (e, i) => {
          var o;
          const t = (o = document.querySelector(`[data-slide-index="${e}"]`)) == null ? void 0 : o.getAttribute("data-media-type");
          return t != null && t.includes("video") ? `<span class=" ${i}"><svg role='none' viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.36228 7.01604L9.36292 7.01565C9.7171 6.8 9.93341 6.41513 9.93341 6.00024C9.93341 5.58534 9.7171 5.20047 9.36292 4.98482L9.3623 4.98445L2.81838 1.06469C2.81832 1.06465 2.81825 1.06461 2.81818 1.06457C2.46421 0.850357 2.02253 0.844776 1.66358 1.05071C1.29144 1.25855 1.06203 1.65392 1.06659 2.08078V9.91961C1.06136 10.3459 1.28949 10.7406 1.66092 10.9497C2.01983 11.155 2.46152 11.1495 2.81494 10.9359C2.81501 10.9359 2.81507 10.9358 2.81513 10.9358L9.36228 7.01604ZM1.93277 2.08017H1.93279L1.93276 2.0785C1.93087 1.96561 1.99091 1.86029 2.08899 1.80466L2.08899 1.80466L2.08957 1.80433C2.132 1.77988 2.17981 1.76705 2.2284 1.76705C2.2774 1.76705 2.32566 1.78096 2.36864 1.80731L2.36864 1.80731L2.36953 1.80785L8.91604 5.72724C9.00972 5.78663 9.06655 5.88946 9.06655 6.00018C9.06655 6.1109 9.00972 6.21374 8.91603 6.27313L2.36953 10.1925L2.36953 10.1925L2.36831 10.1933C2.28353 10.2457 2.17639 10.247 2.0903 10.1964L2.089 10.1957C1.99091 10.1401 1.93087 10.0348 1.93276 9.92186H1.93277V9.92019V2.08017Z" fill="currentColor" stroke="currentColor" stroke-width="0.2"/> </svg></span>` : this.rcpo ? `<span role="button" class="${i} rolex"></span>` : `<span role="button" aria-label="Slide ${e + 1}" class="${i}"><svg role='none' viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.1665 8.91287C7.32752 8.91287 9.07938 7.16102 9.07938 5C9.07938 2.83898 7.32752 1.08713 5.1665 1.08713C3.00548 1.08713 1.25363 2.83898 1.25363 5C1.25363 7.16102 3.00548 8.91287 5.1665 8.91287ZM5.1665 10C7.92793 10 10.1665 7.76142 10.1665 5C10.1665 2.23858 7.92793 0 5.1665 0C2.40508 0 0.166504 2.23858 0.166504 5C0.166504 7.76142 2.40508 10 5.1665 10Z" fill="currentColor"/></svg></span>`;
        }
      },
      breakpoints: {
        640: {
          pagination: !1
        }
      },
      on: {
        afterInit: (e) => {
          this._adjustAriaAttrs(e);
        },
        beforeSlideChangeStart: (e) => {
          this._stopMediaInSlide(e.slides[e.activeIndex]);
        },
        slideChange: (e) => {
          const i = e.slides[e.activeIndex].querySelector("media-player");
          i && i.play();
        }
      }
    };
  }
  _adjustAriaAttrs(e) {
    this.id && e.navigation.nextEl && e.navigation.prevEl && (e.navigation.nextEl.setAttribute("aria-controls", this.id), e.navigation.prevEl.setAttribute("aria-controls", this.id));
  }
  _stopMediaInSlide(e) {
    const i = e.querySelector("media-player");
    i && i.pause();
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), this._containerDialog = this.closest("modal-dialog"), (e = this._containerDialog) == null || e.addEventListener(
      "modal-dialog::close",
      this._handleContainerClose.bind(this)
    );
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._containerDialog) == null || e.removeEventListener(
      "modal-dialog::close",
      this._handleContainerClose.bind(this)
    );
  }
  _handleContainerClose() {
    this.swiperInstance.slides.forEach(this._stopMediaInSlide);
  }
};
s([
  c({ type: Boolean, attribute: "data-rcpo" })
], l.prototype, "rcpo", 2);
l = s([
  d("swiper-with-media")
], l);
export {
  l as SwiperWithMedia
};
